import api from './authService'

export const empresasService = {
  async getEmpresas(params = {}) {
    const response = await api.get('/empresas', { params })
    return response.data
  },

  async getEmpresa(id) {
    const response = await api.get(`/empresas/${id}`)
    return response.data
  },

  async createEmpresa(data) {
    const response = await api.post('/empresas', data)
    return response.data
  },

  async updateEmpresa(id, data) {
    const response = await api.put(`/empresas/${id}`, data)
    return response.data
  },

  async deleteEmpresa(id) {
    const response = await api.delete(`/empresas/${id}`)
    return response.data
  }
}

export default empresasService
